import Axios from 'axios'
import { Notice } from 'view-ui-plus'
import config from '@/config'
import { getToken, removeToken } from '@/libs/util'

const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

// 创建axios实例
export const sysAxios = Axios.create({
  baseURL: baseUrl,
  timeout: 5000,
  withCredentials: true, // 允许携带凭证
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
})

//设置Authorization
export const setAuthorization = () => {
  sysAxios.defaults.headers.Authorization = getToken() ? ('Bearer ' + getToken()) : ''
}

// 响应拦截器
// sysAxios.interceptors.response.use((res) => {
//   if (res.status != 200) {
//     return Promise.reject(res)
//   }
//   return res
// }, (error) => {
//   if (error.response) {
//       // 服务器有内容输出
//       if (error.response.status == '401') {
//           removeToken()
//           const response = error.response;
//           const errorResponse = response.data;
//           const errorMessage = errorResponse.error || errorResponse.message || '未知错误'
//           if(errorMessage.includes('用户名或密码错误')){
//             Notice.info({title: '登录', desc: errorMessage})
//             return
//           }else if(errorMessage.includes('无效的Token')){
//             Notice.info({title: '登录信息失效,2秒后跳转登录界面。'})
//             setTimeout(() => {
//                 // const currentPath = window.location.pathname.toLowerCase();
//                 // // 如果当前路径不是 /login，则跳转到 /login
//                 // if (currentPath !== '/login') {
//                 //     window.location.href = '/login';
//                 // }
//                 window.location.href = '/login';
//             }, 2000);
//             return
//           }
//       }else{
//           // 处理其他错误状态码,如403，500 400、404等）
//           const response = error.response;
//           const errorResponse = response.data;
//           const errorMessage = errorResponse.error || errorResponse.message || '未知错误'
//           Notice.error({title: errorMessage})
//           return
//       }
//   } else if (error.request) {
//       // 请求已发出，但没有收到响应
//       console.error('未收到服务器响应:', error.request);
//   } else {
//       // 其他错误（如网络错误、请求配置错误等）
//       console.error('请求出错:', error.message);
//   }
//   return Promise.reject(error)
// })